/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Master_PasswordInputs */

const en_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master Password`)
};

const es_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña maestra`)
};

const fr_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe principal`)
};

const de_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Master-Passwort`)
};

const ja_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マスターパスワード`)
};

const zh_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主密码`)
};

const ar_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كلمة المرور الرئيسية`)
};

const id_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kata Sandi Utama`)
};

const it_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password Principale`)
};

const ru_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Мастер-пароль`)
};

const pt_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senha Mestre`)
};

const ko_master_password = /** @type {(inputs: Master_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마스터 비밀번호`)
};

/**
* | output |
* | --- |
* | "Master Password" |
*
* @param {Master_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const master_password = /** @type {((inputs?: Master_PasswordInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Master_PasswordInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_master_password(inputs)
	if (locale === "es") return es_master_password(inputs)
	if (locale === "fr") return fr_master_password(inputs)
	if (locale === "de") return de_master_password(inputs)
	if (locale === "ja") return ja_master_password(inputs)
	if (locale === "zh") return zh_master_password(inputs)
	if (locale === "ar") return ar_master_password(inputs)
	if (locale === "id") return id_master_password(inputs)
	if (locale === "it") return it_master_password(inputs)
	if (locale === "ru") return ru_master_password(inputs)
	if (locale === "pt") return pt_master_password(inputs)
	return ko_master_password(inputs)
});